// extracted by mini-css-extract-plugin
export default {"box":"styles_box__40HTz","titleBox":"styles_titleBox__HcFVK","title":"styles_title__RPQk3","description":"styles_description__lNtVU"};